// extracted by mini-css-extract-plugin
export default {"container":"Login_container__QK+p5","grid":"Login_grid__EsHkN","intro":"Login_intro__Dh22U","col1":"Login_col1__P1PuE","col2":"Login_col2__Y2hqc","logos":"Login_logos__A7Gaw"};